export default __webpack_public_path__ + "static/media/8.8f8c91f9.jpg";